import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import DoSurvey from './pages/surveys/DoSurvey';
import StepOne from './pages/surveys/stepOne/StepOne';
import StepTwo from './pages/surveys/stepTwo/StepTwo';
import './pages/surveys/cards.css';
import StepTwoTwo from './pages/surveys/stepTwo/StepTwoTwo';
import StepThree from './pages/surveys/stepThree/StepThree';
import StepThreeTwo from './pages/surveys/stepThree/StepThreeTwo';
import StepThreeThree from './pages/surveys/stepThree/StepThreeThree';
import Thankyou from './pages/surveys/thankyou/Thankyou';
import ErrorPage from './pages/surveys/error/ErrorPage';
import { useEffect, useState } from 'react';
const App = () => {
  const [start, setStart] = useState(false);
  const [seconds, setSeconds] = useState(15 * 60);

  useEffect(() => {
    let interval = null;
    if (seconds > 0) {
      interval = setInterval(() => {
        start && setSeconds((seconds) => seconds - 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [seconds, start]);
  useEffect(() => {
    if (seconds === 0) {
      setSeconds(15 * 60);
    }
  }, [seconds]);
  const minutesDisplay = Math.floor(seconds / 60)
    .toString()
    .padStart(2, '0');
  const secondsDisplay = (seconds % 60).toString().padStart(2, '0');
  window.addEventListener('beforeunload', function (e) {
    e.preventDefault();
    e.returnValue = '';
    // Show a confirmation dialog to the user
    const confirmationMessage =
      'Are you sure you want to leave this page? Your changes may not be saved.';
    e.returnValue = confirmationMessage; // Gecko and Trident
    return confirmationMessage; // Webkit, Safari, Chrome etc.
  });

  return (
    <BrowserRouter>
      <Routes>
        <Route
          exact
          path="/doSurvey/:survey_id"
          element={
            <DoSurvey
              start={start}
              setStart={setStart}
              minutesDisplay={minutesDisplay}
              secondsDisplay={secondsDisplay}
            />
          }
        ></Route>
        <Route
          exact
          path="/stepone"
          element={
            <StepOne
              minutesDisplay={minutesDisplay}
              secondsDisplay={secondsDisplay}
            />
          }
        ></Route>
        <Route
          exact
          path="/steptwo"
          element={
            <StepTwo
              minutesDisplay={minutesDisplay}
              secondsDisplay={secondsDisplay}
            />
          }
        ></Route>
        <Route
          exact
          path="/steptwo-2"
          element={
            <StepTwoTwo
              minutesDisplay={minutesDisplay}
              secondsDisplay={secondsDisplay}
            />
          }
        ></Route>
        <Route
          exact
          path="/stepthree"
          element={
            <StepThree
              minutesDisplay={minutesDisplay}
              secondsDisplay={secondsDisplay}
            />
          }
        ></Route>
        <Route
          exact
          path="/stepthree-2"
          element={
            <StepThreeThree
              minutesDisplay={minutesDisplay}
              secondsDisplay={secondsDisplay}
            />
          }
        ></Route>
        <Route
          exact
          path="/submit"
          element={
            <StepThreeTwo
              final={true}
              minutesDisplay={minutesDisplay}
              secondsDisplay={secondsDisplay}
            />
          }
        ></Route>
        <Route exact path="/success" element={<Thankyou />}></Route>
        <Route path="*" element={<Navigate to="/pageNotfound" />} />
        <Route path="/pageNotfound" element={<ErrorPage />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
